import React, { ReactNode } from "react";
import { Box, Typography, styled } from "@mui/material";

const CardRoot = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.border.primary}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
  padding: theme.spacing(6),
  marginBottom: theme.spacing(4),
}));

interface AccountEditCardProps {
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
  testId?: string;
}

export const AccountEditCard = ({
  title,
  description,
  action,
  children,
  testId,
}: AccountEditCardProps) => (
  <CardRoot data-testid={testId}>
    <Box
      display="flex"
      alignItems="flex-start"
      justifyContent="space-between"
      gap={4}
      mb={5}
    >
      <Box display="flex" flexDirection="column" gap={1} minWidth={0}>
        <Typography variant="h6">{title}</Typography>
        {description && (
          <Typography variant="body3" color="textSecondary">
            {description}
          </Typography>
        )}
      </Box>
      {action}
    </Box>
    {children}
  </CardRoot>
);
